import api from "@/api/contestApi";

export default {
  async signup(params) {
    const {
      email,
      password,
      first_name,
      last_name,
      mobile_number,
      city
    } = params;
    const { data } = await api.post("/site/signup", {
      email,
      password,
      first_name,
      last_name,
      mobile_number,
      city
    });
    return data;
  },

  async login({ email, password }) {
    const { data } = await api.post("/site/login", { email, password });
    return data;
  },

  async logout() {
    const { data } = await api.get(`/site/logout`);
    return data;
  },

  async relogin() {
    const response = await api.get(`/site/relogin`);
    const { success, data: { token } = {} } = response.data;
    return {
      token,
      success: success && !!token
    };
  },

  async resetPasswordRequest(email) {
    const { data } = await api.post(`/site/request-password-reset`, {
      email
    });
    return data;
  },

  async resetPassword(token, password) {
    const { data } = await api.post(`/site/reset-password?token=${token}`, {
      password
    });
    return data;
  },

  async getProfile() {
    const { data } = await api.get("/user/profile");
    return data;
  }
};
